module.exports = __webpack_public_path__ + "img/logo-wsp.3eb1b404.svg";